module.exports = __webpack_public_path__ + "380f58000178c7597fb919d70f0e09e1.png";